export const MAX_CHARACTERS_CONTENT_SEND = 29000;
